'use strict';

var History = /*@ngInject*/ function(RouterTracker) {
  RouterTracker.init();
};

module.exports = History;
